import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

export default function OccupancyChart({ occupancy }) {
  // If no occupancy data is available, don't render anything
  if (!occupancy) return null;
  
  const { total, available, percentage } = occupancy;
  const occupiedPercentage = 100 - percentage;
  
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">Current Occupancy</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500">Occupancy Rate</p>
              <p className="text-2xl font-bold">{occupiedPercentage}%</p>
            </div>
            <div className="text-right space-y-1">
              <p className="text-sm font-medium text-gray-500">Available Units</p>
              <p className="text-2xl font-bold">{available} <span className="text-sm text-gray-500">of {total}</span></p>
            </div>
          </div>
          
          <div className="space-y-2">
            <div className="flex justify-between text-xs text-gray-600">
              <span>0%</span>
              <span>50%</span>
              <span>100%</span>
            </div>
            <Progress value={occupiedPercentage} className="h-3" />
            <div className="flex justify-between text-xs">
              <span className="text-green-600">Available</span>
              <span className="text-blue-600">Occupied</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
